// add for button class="following-scroll" 
// and data-followingscroll=".[class-name(where to scroll)]"

$('.following-scroll').on( 'click', function(event){ 
    event.preventDefault();
    let el = $(this);
    let dest = el.data("followingscroll");
    let fromTop = 90;
    console.log(dest);
    if(dest !== undefined && dest !== '') {
            $('html').animate({
                scrollTop: $(dest).offset().top - fromTop
            }, 1000
        );
    }
    return false;
});